import {
  GET_PROJECTED_RETURN,
  GET_PROJECTED_RETURN_SUCCESS,
  GET_PROJECTED_RETURN_FAILED,
  SET_PROFILE_INFOV2,
  STEP_STARTED,
  GET_TOTAL_UNIT_FUNDS,
  GET_TOTAL_UNIT_FUNDS_SUCCESS,
  GET_TOTAL_UNIT_FUNDS_FAILED,
  PROJECTED_RETURN_INVEST,
  PROJECTED_RETURN_INVEST_SUCCESS,
  PROJECTED_RETURN_INVEST_FAILED,
  UPDATE_CUSTOMER_DUPLICATE,
  UPDATE_CUSTOMER_DUPLICATE_SUCCESS,
  UPDATE_CUSTOMER_DUPLICATE_FAILED,
  GET_RETIREMENT_MIN_AMOUNT,
  GET_RETIREMENT_MIN_AMOUNT_SUCCESS,
  GET_RETIREMENT_MIN_AMOUNT_FAILED,
  GET_RETIREMENT_MAX_AMOUNT,
  GET_RETIREMENT_MAX_AMOUNT_SUCCESS,
  GET_RETIREMENT_MAX_AMOUNT_FAILED,
  GET_RETIREMENT_CARD_INFO,
  GET_RETIREMENT_CARD_INFO_SUCCESS,
  GET_RETIREMENT_CARD_INFO_FAILED,
  GET_MAX_RETIREMENT_YEAR,
  GET_MAX_RETIREMENT_YEAR_SUCCESS,
  GET_MAX_RETIREMENT_YEAR_FAILED,
  GET_MIN_RETIREMENT_YEAR,
  GET_MIN_RETIREMENT_YEAR_SUCCESS,
  GET_MIN_RETIREMENT_YEAR_FAILED,
} from "./constant";


export function getMaxRetirementYear() {
  return {
    type: GET_MAX_RETIREMENT_YEAR,
  };
}
export function getMaxRetirementYearSuccess(payload) {
  return {
    type: GET_MAX_RETIREMENT_YEAR_SUCCESS,
    payload
  };
}

export function getMaxRetirementYearFailed() {
  return {
    type: GET_MAX_RETIREMENT_YEAR_FAILED,
  };
}

export function getMinRetirementYear() {
  return {
    type: GET_MIN_RETIREMENT_YEAR,
  };
}
export function getMinRetirementYearSuccess(payload) {
  return {
    type: GET_MIN_RETIREMENT_YEAR_SUCCESS,
    payload
  };
}

export function getMinRetirementYearFailed() {
  return {
    type: GET_MIN_RETIREMENT_YEAR_FAILED,
  };
}

export function getRetirementCardInfo() {
  return {
    type: GET_RETIREMENT_CARD_INFO,
  };
}
export function getRetirementCardInfoSuccess(payload) {
  return {
    type: GET_RETIREMENT_CARD_INFO_SUCCESS,
    payload
  };
}

export function getRetirementCardInfoFailed() {
  return {
    type: GET_RETIREMENT_CARD_INFO_FAILED,
  };
}

export function getRetirementMaxAmount() {
  return {
    type: GET_RETIREMENT_MAX_AMOUNT
  };
}
export function getRetirementMaxAmountSuccess(payload) {
  return {
    type: GET_RETIREMENT_MAX_AMOUNT_SUCCESS,
    payload
  };
}

export function getRetirementMaxAmountFailed() {
  return {
    type: GET_RETIREMENT_MAX_AMOUNT_FAILED,
  };
}

export function getRetirementMinAmount() {
  return {
    type: GET_RETIREMENT_MIN_AMOUNT
  };
}
export function getRetirementMinAmountSuccess(payload) {
  return {
    type: GET_RETIREMENT_MIN_AMOUNT_SUCCESS,
    payload
  };
}

export function getRetirementMinAmountFailed() {
  return {
    type: GET_RETIREMENT_MIN_AMOUNT_FAILED,
  };
}

export function updateCustomerDuplicate(payload, callback) {
  return {
    type: UPDATE_CUSTOMER_DUPLICATE,
    payload,
    callback,
  };
}
export function updateCustomerDuplicateSuccess() {
  return {
    type: UPDATE_CUSTOMER_DUPLICATE_SUCCESS,
  };
}

export function updateCustomerDuplicateFailed() {
  return {
    type: UPDATE_CUSTOMER_DUPLICATE_FAILED,
  };
}

export function getTotalUnitFunds(payload) {
  return {
    type: GET_TOTAL_UNIT_FUNDS,
    payload,
  };
}
export function getTotalUnitFundsSuccess(payload) {
  return {
    type: GET_TOTAL_UNIT_FUNDS_SUCCESS,
    payload,
  };
}

export function getTotalUnitFundsFailed() {
  return {
    type: GET_TOTAL_UNIT_FUNDS_FAILED,
  };
}

export function getProjectedReturn() {
  return {
    type: GET_PROJECTED_RETURN,
  };
}

export function getProjectedReturnSuccess(data) {
  return {
    type: GET_PROJECTED_RETURN_SUCCESS,
    payload: data,
  };
}

export function getProjectedReturnFailed(data) {
  return {
    type: GET_PROJECTED_RETURN_FAILED,
    payload: data,
  };
}

export function setProfileInfoV2(payload) {
  return {
    type: SET_PROFILE_INFOV2,
    payload,
  };
}

export function setStepStarted(payload) {
  return {
    type: STEP_STARTED,
    payload,
  };
}

export function getProjectedReturnInvest() {
  return {
    type: PROJECTED_RETURN_INVEST,
  };
}

export function getProjectedReturnInvestSuccess(data) {
  return {
    type: PROJECTED_RETURN_INVEST_SUCCESS,
    payload: data,
  };
}

export function getProjectedReturnInvestFailed(data) {
  return {
    type: PROJECTED_RETURN_INVEST_FAILED,
    payload: data,
  };
}
